export const GET_NOTIFICATIONS = 'entities/GET_NOTIFICATIONS'
